/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListSlackDirectoryConnectionsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListSlackDirectoryConnectionsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListSlackDirectoryConnectionsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListSlackDirectoryConnectionsSecurity$outboundSchema:
  z.ZodMiniType<
    ListSlackDirectoryConnectionsSecurity$Outbound,
    ListSlackDirectoryConnectionsSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listSlackDirectoryConnectionsSecurityToJSON(
  listSlackDirectoryConnectionsSecurity: ListSlackDirectoryConnectionsSecurity,
): string {
  return JSON.stringify(
    ListSlackDirectoryConnectionsSecurity$outboundSchema.parse(
      listSlackDirectoryConnectionsSecurity,
    ),
  );
}

/** @internal */
export type ListSlackDirectoryConnectionsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListSlackDirectoryConnectionsRequest$outboundSchema: z.ZodMiniType<
  ListSlackDirectoryConnectionsRequest$Outbound,
  ListSlackDirectoryConnectionsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function listSlackDirectoryConnectionsRequestToJSON(
  listSlackDirectoryConnectionsRequest: ListSlackDirectoryConnectionsRequest,
): string {
  return JSON.stringify(
    ListSlackDirectoryConnectionsRequest$outboundSchema.parse(
      listSlackDirectoryConnectionsRequest,
    ),
  );
}
